import {Route, Routes, Outlet} from 'react-router-dom'
import ListWrapper from './list/ListWrapper'
import ViewWrapper from './view/ViewWrapper'

const CustomersPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path='/' element={<ListWrapper />} />
      <Route path='/:id/*' element={<ViewWrapper />} />
    </Route>
  </Routes>
)

export default CustomersPage
